export type ServiceType = {
	name: string;
	img: string;
	src: string;
};
export const services: ServiceType[] = [
	{
		name: 'Покраска внутри помещения',
		img:
			'https://cdn.lemanapro.ru/lmru/image/upload/v1725980366/fudzi/elbrus/images/landings/rough-work/Штукатурка 3.png/Штукатурка 3.png',
		src: '/uslugi/catalogue/pokraska-vnutri-pomeshcheniya/',
	},
	{
		name: 'Укладка напольных покрытий',
		img:
			'https://cdn.lemanapro.ru/lmru/image/upload/v1725982997/fudzi/elbrus/images/landings/rough-work/Штукатурка 3 (1).png/Штукатурка 3 (1).png',
		src: '/uslugi/catalogue/ukladka-napolnyh-pokrytiy/',
	},
	{
		name: 'Установка входных дверей',
		img:
			'https://cdn.lemanapro.ru/lmru/image/upload/v1725982997/fudzi/elbrus/images/landings/rough-work/Штукатурка 3 (2).png/Штукатурка 3 (2).png',
		src: '/uslugi/catalogue/ustanovka-metallicheskoy-dveri/',
	},
];
